import { post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const invoicePortalUrl = "api/v1/invoiceportal/customersignonlink";

export interface CustomerSignOnLinkModel extends BaseModel {
    signOnLink?: string;
}

export function getCustomerSignOnLink() {
    return post<{}, CustomerSignOnLinkModel>(invoicePortalUrl);
}
